'use strict';

export class URLHelper {
  static cleanupSearchFilter(searchFilter: string) {
    return (searchFilter || "").replace(/[']/g, "").replace(/[ ]+/g, " ");
  }

  static hasOnlyNumericCharacters(searchFilter: string): boolean {
  return !!searchFilter.match(/^([0-9]+)|([0-9]+\.[0=9]+)$/);
  }
  
  static buildGeneralSearchFilter(columns: any, searchFilter: string) {
    if (searchFilter == '*') return 'with=all=1';
    let searchFilters = this.cleanupSearchFilter(searchFilter).split(" ");
    if (typeof searchFilters === 'string') searchFilters = [searchFilters];
    let list = [];
    for (let filter of searchFilters) {
      let query = [];
      for (let key in columns) {
        if (columns[key] == 'string') query.push(key + "==\'*" + encodeURIComponent(filter) + "*\'");
        else if (columns[key] == 'number' && this.hasOnlyNumericCharacters(filter)) query.push(key + '==' + encodeURIComponent(filter));
      }
      list.push('(' + query.join(',') + ')');
    }
    return list.join(';').replace(/\*+/g, '*');
  }
  
  static buildQueryString(prefix: string, hash: any, suffix: string) {
    let list = [];
    
    if (prefix) list.push(prefix);
    for (let key in hash) {
      list.push(key + '=' + hash[key]);
    }
    if (suffix) list.push(suffix);
    
    let query = list.join('&').replace(/&+/g, "&").replace(/\?+/g, "?").replace(/\?&/g, "?");
    return query;
  }
}


// WEBPACK FOOTER //
// ./src/app/helpers/url.helper.ts